import { render, staticRenderFns } from "./VaRating.demo.vue?vue&type=template&id=501fc808&"
import script from "./VaRating.demo.vue?vue&type=script&lang=js&"
export * from "./VaRating.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports